module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "model-name"
  }, [_c('div', {
    staticClass: "model-center"
  }, [_c('img', {
    staticClass: "face",
    attrs: {
      "src": require("../static/images/model-face.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "model-close",
    attrs: {
      "src": require("../static/images/model-close.png"),
      "alt": ""
    },
    on: {
      "click": _vm.closeModel
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "model-tittle"
  }, [_vm._v("请留下您的姓名与电话，商务人员会主动联系您")]), _vm._v(" "), _c('div', {
    staticClass: "boder-div "
  }, [_c('img', {
    attrs: {
      "src": require("../static/images/model-name.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boder-div boder-div-second "
  }, [_c('img', {
    attrs: {
      "src": require("../static/images/model-phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "电话"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.submission
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0126f4c","hasScoped":true}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModelName.vue
// module id = 483
// module chunks = 0 1 2 3 4 5 6 7 8